
import React from 'react';
import ComponentWrapper from './ComponentWrapper';
import HomePage from './components/HomePage';
import AboutUs from './components/AboutUs';
import Contact from './components/Contact';
import PrivacyPolicy from './components/PrivacyPolicy';
import BixbitePricing from './components/BixbitePricing';
import LoCoPilot from './components/LoCoPilot';

const RoutesConfig = [
  { path: "/", element: <ComponentWrapper component={LoCoPilot} componentName="LoCoPilot" componentPath="src/components/LoCoPilot.js" /> },
  { path: "/home", element: <ComponentWrapper component={HomePage} componentName="HomePage" componentPath="src/components/HomePage.js" /> },
  { path: "/locopilot", element: <ComponentWrapper component={LoCoPilot} componentName="LoCoPilot" componentPath="src/components/LoCoPilot.js" /> },
  { path: "/about", element: <ComponentWrapper component={AboutUs} componentName="AboutUs" componentPath="src/components/AboutUs.js" /> },
  { path: "/contact", element: <ComponentWrapper component={Contact} componentName="Contact" componentPath="src/components/Contact.js" /> },
  { path: "/privacy-policy", element: <ComponentWrapper component={PrivacyPolicy} componentName="PrivacyPolicy" componentPath="src/components/PrivacyPolicy.js" /> },
  { path: "/bixbite_pricing", element: <ComponentWrapper component={BixbitePricing} componentName="BixbitePricing" componentPath="src/components/BixbitePricing.js" /> },
];

export default RoutesConfig;
